import { BaseClient } from "../../../http/base-client";
import z from "zod";

export class RequestClient extends BaseClient {
  public async submit(request: string) {
    return await this.post({
      url: "/api/requests",
      bodySchema: z.object({
        request: z.string().min(1),
      }),
      body: { request },
    });
  }

  public async byId(requestId: string) {
    return await this.get({
      url: `/api/requests/${requestId}`,
    });
  }

  public async byCheckoutSession(sessionId: string) {
    return await this.get({
      url: `/api/payments/checkout-sessions/${sessionId}/request`,
    });
  }

  public async updateVisibility(requestId: string, isPublic: boolean) {
    return await this.patch({
      url: `/api/requests/${requestId}/visibility`,
      bodySchema: z.object({
        isPublic: z.boolean(),
      }),
      body: { isPublic },
    });
  }

  public async resubmit(requestId: string, request: string) {
    return await this.post({
      url: `/api/requests/${requestId}/resubmit`,
      bodySchema: z.object({
        request: z.string().min(1),
      }),
      body: { request },
    });
  }
}
